// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsBlock__zkF0A {
  height: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr;
  background-color: var(--tables-secondary-row-sub-title-surface);
  box-shadow: var(--basic-box-shadow);
}

.blockHead__dYmmq {
  padding: 10.5px 20px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.blockTitle__hK0N0 {
  font-size: 11px;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  column-gap: 3px;
}

.blockTitleShort__xlKw7 {
  grid-column: 1/4;
}

.sortIcon__YtPI8 {
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__YtPI8 path {
  fill: var(--tables-title-icon);
}

.facilityBlock__xDgR3 {
  background-color: var(--tables-primary-row-surface-default);
  border-right: 1px solid var(--tables-title-stroke);
}

.facilityBlockHead__YpjBq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 25px;
  min-height: 74px;
}

.facilityItem__niItF {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: var(--tables-primary-row-text-main);
  text-transform: uppercase;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  column-gap: 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.facilityItem__niItF:hover {
  background-color: var(--tables-primary-row-surface-selected);
}

.notificationsBlockBody__V6cgd {
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.notificationsBlockBodyShort__Lqes0 {
  height: 275px;
  overflow-y: auto;
}

.notificationsBlockHead__V8aTT {
  display: grid;
  grid-template-columns: repeat(3, 100px);
  grid-template-rows: auto 1fr;
  column-gap: 20px;
  row-gap: 10px;
}
.notificationsBlockHead__V8aTT > span {
  grid-column: 1/4;
}
@media (max-width: 850px) {
  .notificationsBlockHead__V8aTT {
    grid-template-columns: repeat(3, 85px);
  }
}

.emptyBlockWrapper__MS5xK {
  max-height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.emptyBlockText__v8P1q {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-primary-row-text-additional);
}

.checkboxHigh__TIZEI {
  border: 1px solid var(--labels-outline-stroke-text-high);
}
.checkboxHigh__TIZEI div {
  background-color: var(--labels-outline-stroke-text-high);
}
.checkboxHigh__TIZEI ~ p {
  text-transform: uppercase;
}

.checkboxStandard__fnWle {
  text-transform: uppercase;
  border: 1px solid var(--labels-outline-stroke-text-standard);
}
.checkboxStandard__fnWle div {
  background-color: var(--labels-outline-stroke-text-standard);
}
.checkboxStandard__fnWle ~ p {
  text-transform: uppercase;
}

.checkboxCritical__uH9aG {
  text-transform: uppercase;
  border: 1px solid var(--labels-outline-stroke-text-critical);
}
.checkboxCritical__uH9aG div {
  background-color: var(--labels-outline-stroke-text-critical);
}
.checkboxCritical__uH9aG ~ p {
  text-transform: uppercase;
}

.notificationsRow__gMvxh {
  padding: 15px 20px;
  display: grid;
  grid-template-columns: repeat(3, 100px);
  grid-template-rows: auto 1fr;
  row-gap: 10px;
  column-gap: 20px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
@media (max-width: 850px) {
  .notificationsRow__gMvxh {
    grid-template-columns: repeat(3, 85px);
  }
}

.notificationsRowName__rBu2z {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
  grid-column: 1/4;
}

.checkboxSkeleton__XrpbQ {
  width: 24px;
  height: 24px;
}

.textSkeleton__k5117 {
  width: 100%;
  height: 16px;
}

.mainBodyText__OJ_nb {
  margin-top: 5px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/EmailNotificationsUser/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,+DAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,oBAAA;EACA,mDAAA;EACA,uCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,aAAA;EACA,cAAA;AAzEF;AA2EE;EACE,8BAAA;AAzEJ;;AA6EA;EACE,2DAAA;EACA,kDAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yDAAA;AA1EF;AA4EE;EACE,4DAAA;AA1EJ;;AA6EA;EACE,+DAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,uCAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;AA1EF;AA4EE;EACE,gBAAA;AA1EJ;AA6EE;EAXF;IAYI,sCAAA;EA1EF;AACF;;AA6EA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+DAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;AA1EF;;AA6EA;EACE,wDAAA;AA1EF;AA4EE;EACE,wDAAA;AA1EJ;AA6EE;EACE,yBAAA;AA3EJ;;AA+EA;EACE,yBAAA;EACA,4DAAA;AA5EF;AA8EE;EACE,4DAAA;AA5EJ;AA+EE;EACE,yBAAA;AA7EJ;;AAiFA;EACE,yBAAA;EACA,4DAAA;AA9EF;AAgFE;EACE,4DAAA;AA9EJ;AAiFE;EACE,yBAAA;AA/EJ;;AAmFA;EACE,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,4BAAA;EACA,aAAA;EACA,gBAAA;EACA,yDAAA;AAhFF;AAkFE;EATF;IAUI,sCAAA;EA/EF;AACF;;AAkFA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,gBAAA;AA/EF;;AAkFA;EACE,WAAA;EACA,YAAA;AA/EF;;AAkFA;EACE,WAAA;EACA,YAAA;AA/EF;;AAkFA;EACE,eAAA;EACA,mBAAA;AA/EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.settingsBlock {\n  height: 100%;\n  display: grid;\n  grid-template-columns: 2fr 3fr;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n  box-shadow: var(--basic-box-shadow);\n}\n\n.blockHead {\n  padding: 10.5px 20px;\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  display: flex;\n  align-items: center;\n  column-gap: 3px;\n}\n\n.blockTitleShort {\n  grid-column: 1/4;\n}\n\n.sortIcon {\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.facilityBlock {\n  background-color: var(--tables-primary-row-surface-default);\n  border-right: 1px solid var(--tables-title-stroke);\n}\n\n.facilityBlockHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 25px;\n  min-height: 74px;\n}\n\n.facilityItem {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-main);\n  text-transform: uppercase;\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 25px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  &:hover {\n    background-color: var(--tables-primary-row-surface-selected);\n  }\n}\n.notificationsBlockBody {\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n\n.notificationsBlockBodyShort {\n  height: 275px;\n  overflow-y: auto;\n}\n\n.notificationsBlockHead {\n  display: grid;\n  grid-template-columns: repeat(3, 100px);\n  grid-template-rows: auto 1fr;\n  column-gap: 20px;\n  row-gap: 10px;\n\n  & > span {\n    grid-column: 1/4;\n  }\n\n  @media (max-width: 850px) {\n    grid-template-columns: repeat(3, 85px);\n  }\n}\n\n.emptyBlockWrapper {\n  max-height: 450px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n\n.emptyBlockText {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-additional);\n}\n\n.checkboxHigh {\n  border: 1px solid var(--labels-outline-stroke-text-high);\n\n  div {\n    background-color: var(--labels-outline-stroke-text-high);\n  }\n\n  & ~ p {\n    text-transform: uppercase;\n  }\n}\n\n.checkboxStandard {\n  text-transform: uppercase;\n  border: 1px solid var(--labels-outline-stroke-text-standard);\n\n  div {\n    background-color: var(--labels-outline-stroke-text-standard);\n  }\n\n  & ~ p {\n    text-transform: uppercase;\n  }\n}\n\n.checkboxCritical {\n  text-transform: uppercase;\n  border: 1px solid var(--labels-outline-stroke-text-critical);\n\n  div {\n    background-color: var(--labels-outline-stroke-text-critical);\n  }\n\n  & ~ p {\n    text-transform: uppercase;\n  }\n}\n\n.notificationsRow {\n  padding: 15px 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 100px);\n  grid-template-rows: auto 1fr;\n  row-gap: 10px;\n  column-gap: 20px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  @media (max-width: 850px) {\n    grid-template-columns: repeat(3, 85px);\n  }\n}\n\n.notificationsRowName {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  grid-column: 1/4;\n}\n\n.checkboxSkeleton {\n  width: 24px;\n  height: 24px;\n}\n\n.textSkeleton {\n  width: 100%;\n  height: 16px;\n}\n\n.mainBodyText {\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsBlock": `settingsBlock__zkF0A`,
	"blockHead": `blockHead__dYmmq`,
	"blockTitle": `blockTitle__hK0N0`,
	"blockTitleShort": `blockTitleShort__xlKw7`,
	"sortIcon": `sortIcon__YtPI8`,
	"facilityBlock": `facilityBlock__xDgR3`,
	"facilityBlockHead": `facilityBlockHead__YpjBq`,
	"facilityItem": `facilityItem__niItF`,
	"notificationsBlockBody": `notificationsBlockBody__V6cgd`,
	"notificationsBlockBodyShort": `notificationsBlockBodyShort__Lqes0`,
	"notificationsBlockHead": `notificationsBlockHead__V8aTT`,
	"emptyBlockWrapper": `emptyBlockWrapper__MS5xK`,
	"emptyBlockText": `emptyBlockText__v8P1q`,
	"checkboxHigh": `checkboxHigh__TIZEI`,
	"checkboxStandard": `checkboxStandard__fnWle`,
	"checkboxCritical": `checkboxCritical__uH9aG`,
	"notificationsRow": `notificationsRow__gMvxh`,
	"notificationsRowName": `notificationsRowName__rBu2z`,
	"checkboxSkeleton": `checkboxSkeleton__XrpbQ`,
	"textSkeleton": `textSkeleton__k5117`,
	"mainBodyText": `mainBodyText__OJ_nb`
};
module.exports = ___CSS_LOADER_EXPORT___;
